import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { copyAttachment } from "utils/attachmentClipboard";

const COPIED_FEEDBACK_MS = 1500;

/** Copies one attachment so it can be pasted into another note, comment or app. */
const CopyAttachmentButton = ({ url, iconSize = 14, className = "" }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
    return () => clearTimeout(timer);
  }, [copied]);

  const handleCopy = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    try {
      const kind = await copyAttachment(url);
      setCopied(true);
      toast.success(
        kind === "image"
          ? "Image copied. Paste it into any note, comment or app."
          : "Attachment copied. Paste it into any note or comment to attach it."
      );
    } catch {
      toast.error("Could not copy this attachment. Check the browser's clipboard permission.");
    }
  };

  if (!url) return null;

  return (
    <Tooltip title={copied ? "Copied" : "Copy attachment"}>
      <IconButton
        size="small"
        onClick={handleCopy}
        aria-label="Copy attachment"
        className={className}
      >
        {copied ? (
          <CheckIcon sx={{ fontSize: iconSize }} />
        ) : (
          <ContentCopyIcon sx={{ fontSize: iconSize }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default CopyAttachmentButton;
